export const SET_LOADING = "SET_LOADING"
export const SET_SNAG_PROJECTS = "SET_SNAG_PROJECTS";
export const SET_PANEL_DELIVERY_REPORTS = "SET_PANEL_DELIVERY_REPORTS";
export const SET_PRODUCTION_SUMMARY_PROJECTS = "SET_PRODUCTION_SUMMARY_PROJECTS";
export const SET_SNACK = "SET_SNACK"
export const SET_SNACK_INFO = "SET_SNACK_INFO"
export const SET_USER_DETAILS = "SET_USER_DETAILS"
export const GET_ALL_SCOPES = "GET_ALL_SCOPES"
export const GET_ALL_UNITS = "GET_ALL_UNITS"
export const GET_ALL_PAYMENT_MODES = "GET_ALL_PAYMENT_MODES"
export const GET_APPROVED_PROJECTS = "GET_APPROVED_PROJECTS"
export const GET_ALL_PROJECTS = "GET_ALL_PROJECTS"
export const GET_ALL_ROLES = "GET_ALL_ROLES"
export const GET_ALL_UNIQUE_ROLE_FIELDS = "GET_ALL_UNIQUE_ROLE_FIELDS"
export const GET_ALL_MATERIALS = "GET_ALL_MATERIALS"
export const GET_ALL_SUB_CATEGORY = "GET_ALL_SUB_CATEGORY"
export const SET_VENDOR_NAME = 'SET_VENDOR_NAME'
export const GET_ALL_PAYMENT_PARTNERS = 'GET_ALL_PAYMENT_PARTNERS'
export const SET_LOGIN_SUCCESS = 'SET_LOGIN_SUCCESS'
export const SET_LOGOUT = 'SET_LOGOUT'
export const SET_CUSTOMER_DETAILS ='SET_CUSTOMER_DETAILS'
export const SET_LEAD_SOURCE = "SET_LEAD_SOURCE";
export const SET_SALES_DATA = "SET_SALES_DATA";
export const SET_USERS_DATA = "SET_USERS_DATA";
export const SET_SALES_STAGE_LEAD = "SET_SALES_STAGE_LEAD";
export const CLEAR_SALES_DATA = "CLEAR_SALES_DATA";
export const LOGOUT = "LOGOUT";
export const SET_SALESL2M_DATA = "SET_SALESL2M_DATA";
export const CLEAR_L2M_DATA = "CLEAR_L2M_DATA";
export const PROJECT_NO = "PROJECT No";
export const SET_DESIGN_STAGE_LEAD = "SET_DESIGN_STAGE_LEAD";
export const SET_MEETING_TRACKER = "SET_MEETING_TRACKER";
export const SET_STAGE_REVIEW = "SET_STAGE_REVIEW";
export const MONTHLY_CONVERSION_GOAL = "MONTHLY_CONVERSION_GOAL";
export const LEADS_GENERATED_DASHBOARD = "LEADS_GENERATED_DASHBOARD";
export const LEAD_SOURCE_TYPE_BOOKING_REPORT = "LEAD_SOURCE_TYPE_BOOKING_REPORT";
export const LEADS_SOURCE_TRACKER = "LEADS_SOURCE_TRACKER";
export const LEADS_LIFECYCLE_DASHBOARD = "LEADS_LIFECYCLE_DASHBOARD";
export const CHANNEL_PARTNER_DASHBOARD = "CHANNEL_PARTNER_DASHBOARD ";
export const IDSO_DASHBOARD = "IDSO_DASHBOARD ";
export const DSO_DASHBOARD = "DSO_DASHBOARD ";
export const SOD_DASHBOARD = "SOD_DASHBOARD ";
export const SOC_DASHBOARD = "SOC_DASHBOARD ";
export const PPS_DASHBOARD = "PPS_DASHBOARD ";
export const UES_DASHBOARD = "UES_DASHBOARD ";
export const SET_ROUTE_ACCESS = "SET_ROUTE_ACCESS";
export const SET_MARKETING_ADS_FILTERS = "SET_MARKETING_ADS_FILTERS";
export const SET_MARKETING_ADS_META = "SET_MARKETING_ADS_META";
export const SET_MARKETING_ADS_GOOGLE = "SET_MARKETING_ADS_GOOGLE";
export const SET_MARKETING_ADS_COMBINED = "SET_MARKETING_ADS_COMBINED";
export const CLEAR_MARKETING_ADS = "CLEAR_MARKETING_ADS";
